import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import './index.css'
import './features/styles/features-shell.css'
import './themes/activeThemeCss'
import App from './App.tsx'
import { emitPwaUpdateAvailable } from './shared/lib/pwaUpdate'
import { initSentryHybrid } from './shared/lib/sentryConsent'

initSentryHybrid()

if (import.meta.env.PROD) {
  const updateSW = registerSW({
    immediate: true,
    // Client-side routing never reloads the page, so the browser would only look for a new SW on a full load
    onRegisteredSW(_url, registration) {
      if (!registration) return
      const check = () => void registration.update().catch(() => undefined)
      window.setInterval(check, 15 * 60 * 1000)
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') check()
      })
    },
    onNeedRefresh() {
      emitPwaUpdateAvailable({
        reload: () => {
          void updateSW(true)
        },
      })
    },
  })
}

if (import.meta.env.DEV) {
  // En dev, le SW peut servir des assets obsolètes et fausser les tests manuels.
  // On le désactive explicitement.
  void navigator.serviceWorker?.getRegistrations?.().then((regs) => regs.forEach((r) => r.unregister()))
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
